import { atom } from 'jotai';

export const experienceAtom = atom(null);
